<h3 translate class="page-title text-center">OPEN_ORDER_ROWS</h3>
<lib-filter-list [configService]="config"></lib-filter-list>
